// import BloodtypeIcon from "@mui/icons-material/Bloodtype";
// import PaymentsIcon from "@mui/icons-material/Payments";
// import styles from "./ServiceCard.module.css";
// import AdherentesList from "./AdherentesList";
// import { GiCandleLight } from "react-icons/gi";
// import { GiDeathSkull } from "react-icons/gi";
// import { LiaCrossSolid } from "react-icons/lia";

// const ServiceCard = ({ title, data, type }) => {
//   const { activo, titular, adherentes } = data;

//   const getIcon = () => {
//     switch (type) {
//       case "bancoSangre":
//         return <BloodtypeIcon style={{ fontSize: 30, color: "#696969" }} />; // Rojo
//       case "sepelio":
//         return (
//           <GiCandleLight
//             fontSize="large"
//             style={{ fontSize: 30, color: "#696969" }}
//           />
//         );
//       case "subsidioFallecimiento":
//         return <LiaCrossSolid style={{ fontSize: 30, color: "#696969" }} />; // Azul
//       default:
//         return null;
//     }
//   };

//   return (
//     <div className={styles.card}>
//       <div className={styles.header}>
//         <div className={styles.iconWrapper}>{getIcon()}</div>
//         <span
//           className={`${styles.badge} ${activo ? styles.active : styles.inactive}`}
//         >
//           {activo ? "Activo" : "Inactivo"}
//         </span>
//       </div>

//       <h3 className={styles.title}>{title}</h3>

//       <div className={styles.info}>
//         {activo && (
//           <>
//             <div className={styles.role}>
//               <span className={styles.roleValue}> Titular:</span>
//               {titular?.Nombre}
//             </div>
//             <div className={styles.role}>
//               <span className={styles.roleValue}> DNI:</span>
//               {titular?.NroDocPer}
//             </div>
//           </>
//         )}

//         {activo && adherentes && adherentes.length > 0 && (
//           <AdherentesList adherentes={adherentes} />
//         )}
//       </div>
//     </div>
//   );
// };

// export default ServiceCard;

import styles from "./ServiceCard.module.css";
import AdherentesList from "./AdherentesList";

// Reemplazo de los imports de iconos por imports de imágenes PNG
// Asegúrate de que la ruta ../../../img/ sea la correcta desde este componente
import iconBancoSangre from "../../img/Sangre.png"; // Ajusté nombre a snake_case por convención, cambialo si no coincide
import iconSepelio from "../../img/Servicio de Sepelio.png";
import iconSubsidio from "../../img/fallecimiento.png";
import Btn from "../btn/btn";

const ServiceCard = ({ title, data, type }) => {
  const { activo, titular, adherentes, mensajeAdherir, urlAdherir } = data;

  const imgWidth = 45;
  const imgHeight = 45;

  const getIcon = () => {
    switch (type) {
      case "bancoSangre":
        return (
          <img
            src={iconBancoSangre}
            alt="Banco de Sangre"
            style={{ width: imgWidth, height: imgHeight, objectFit: "contain" }}
          />
        );
      case "sepelio":
        return (
          <img
            src={iconSepelio}
            alt="Sepelio"
            style={{ width: imgWidth, height: imgHeight, objectFit: "contain" }}
          />
        );
      case "subsidioFallecimiento":
        return (
          <img
            src={iconSubsidio}
            alt="Subsidio Fallecimiento"
            style={{ width: imgWidth, height: imgHeight, objectFit: "contain" }}
          />
        );
      default:
        return null;
    }
  };

  return (
    <div className={styles.card}>
      <div className={styles.header}>
        <div className={styles.iconWrapper}>{getIcon()}</div>
        <span
          className={`${styles.badge} ${activo ? styles.active : styles.inactive}`}
        >
          {activo ? "Adherido" : "No adherido"}
        </span>
      </div>

      <h3 className={styles.title}>{title}</h3>

      <div className={styles.info}>
        {activo && (
          <>
            <div className={styles.role}>
              <span className={styles.roleValue}> Titular:</span>
              {titular?.Nombre}
            </div>
            <div className={styles.role}>
              <span className={styles.roleValue}> DNI:</span>
              {titular?.NroDocPer}
            </div>
          </>
        )}

        {activo && adherentes && adherentes.length > 0 && (
          <AdherentesList adherentes={adherentes} />
        )}

        {/* Mensaje de adhesión cuando el servicio no está activo */}

        <p className={styles.message}>{mensajeAdherir}</p>
        <div className={styles.buttonContainer}>
          <Btn
            color="info"
            text="Consultar requisitos"
            action={() => window.open(urlAdherir, "_blank")}
          />
        </div>
      </div>
    </div>
  );
};

export default ServiceCard;
